import Vuex from "vuex";
import Vue from "vue";

//good Vuex examples with modules
//https://www.ictshore.com/javascript/vuex-modules-tutorial/

//modules
import currentUser from "./modules/currentUser";

//Load Vuex
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    currentUser
    // other modules here ...
  }
});
